document.addEventListener('DOMContentLoaded', function(){
   $('#for-life-section .multicolumn-list').slick({
      dots: true,
      infinite: true,
      speed: 4000, // Slower transition speed
      autoplay: true,
      autoplaySpeed: 0, // Keeps continuous movement
      arrows: false,
      slidesToShow: 3,
      slidesToScroll: 1,
     cssEase: 'linear', 
      responsive: [
        {
          breakpoint: 768, // Tablets and below
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });



  $('#patient-journeys .multicolumn-list').slick({
      dots: true,
      infinite: true,
      speed: 4000, // Slower transition speed
      autoplay: true,
      autoplaySpeed: 0, // Keeps continuous movement
      arrows: false,
      slidesToShow: 2.5,
      slidesToScroll: 1,
    cssEase: 'linear', 
      responsive: [
        {
          breakpoint: 768, // Tablets and below
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });


    document.querySelectorAll(".image-with-text__text--caption a").forEach(link => {
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noopener noreferrer");
    });




    // Initially add 'active' class
    document.querySelectorAll(".weight").forEach(el => el.classList.add("active"));
    document.querySelector("#shopify-section-template--24594661474637__featured_blog_YpJVDg .blog").classList.add("active");

    // Object mapping buttons to their corresponding sections
    const mapping = {
        ".medication": "#shopify-section-template--24594661474637__featured_blog_nULf69 .blog",
        ".nutrition": "#shopify-section-template--24594661474637__featured_blog_b6Edzh .blog",
        ".exercise": "#shopify-section-template--24594661474637__featured_blog_J8YRaK .blog",
        ".womens-health": "#shopify-section-template--24594661474637__featured_blog_qr9iFL .blog",
        ".wellbeing": "#shopify-section-template--24594661474637__featured_blog_YpahGF .blog",
        ".weight": "#shopify-section-template--24594661474637__featured_blog_YpJVDg .blog"
    };

    Object.keys(mapping).forEach(selector => {
        document.querySelector(selector)?.addEventListener("click", function () {
            // Remove 'active' class from all target blog sections
            document.querySelectorAll(".blog").forEach(blog => blog.classList.remove("active"));

            // Remove 'active' from all clickable elements
            Object.keys(mapping).forEach(btn => {
                document.querySelector(btn)?.classList.remove("active");
            });

            // Add 'active' to the corresponding blog section
            const target = document.querySelector(mapping[selector]);
            if (target) {
                target.classList.add("active");
            }

            // Add 'active' to the clicked element
            this.classList.add("active");
        });
    });









  

  
 });




// document.addEventListener('DOMContentLoaded', function () {
//     function initializeSlick(selector, settings) {
//         const $slider = $(selector + ' .multicolumn-list');

//         if ($slider.hasClass('slick-initialized')) {
//             $slider.slick('refresh'); // Refresh if already initialized
//         } else {
//             $slider.slick(settings);
//         }
//     }

//     function checkAndInitialize(selector, settings) {
//         const section = document.querySelector(selector);
//         if (!section) return;

//         const observer = new IntersectionObserver(
//             (entries, observer) => {
//                 entries.forEach((entry) => {
//                     if (entry.isIntersecting) {
//                         setTimeout(() => {
//                             initializeSlick(selector, settings);
//                             $(window).trigger('resize'); // Force recalculation
//                         }, 600); // Allow animations to finish

//                         observer.unobserve(entry.target);
//                     }
//                 });
//             },
//             { threshold: 0.2 } // Lower threshold for early detection
//         );

//         observer.observe(section);
//     }

//     // Slick settings for both sections
//     const slickSettingsForLife = {
//         dots: true,
//         infinite: false,
//         speed: 500,
//         autoplay: false,
//         autoplaySpeed: 5000,
//         arrows: false,
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         responsive: [
//             {
//                 breakpoint: 768,
//                 settings: {
//                     slidesToShow: 1
//                 }
//             }
//         ]
//     };

//     const slickSettingsPatientJourneys = {
//         dots: true,
//         infinite: false,
//         speed: 500,
//         autoplay: false,
//         autoplaySpeed: 5000,
//         arrows: false,
//         slidesToShow: 2.5,
//         slidesToScroll: 1,
//         responsive: [
//             {
//                 breakpoint: 768,
//                 settings: {
//                     slidesToShow: 1
//                 }
//             }
//         ]
//     };

//     checkAndInitialize('#for-life-section', slickSettingsForLife);
//     checkAndInitialize('#patient-journeys', slickSettingsPatientJourneys);

//     // 💡 Extra Fix: Ensure Slick Works on Small Screens
//     function forceSlickRefresh() {
//         requestAnimationFrame(() => {
//             setTimeout(() => {
//                 $('.multicolumn-list').slick('refresh');
//             }, 500);
//         });
//     }

//     // Fix Slick when resizing the window
//     window.addEventListener('resize', forceSlickRefresh);

//     // Fix Slick after animations have fully loaded (Useful for first section)
//     window.addEventListener('load', forceSlickRefresh);
// });
